import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import useAuthCheck from "./hooks/useAuthCheck";

import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";

import HomePage from "./pages/HomePage";

import StudentLogin from "./pages/Student/StudentLogin";
import StudentRegistration from "./pages/Student/StudentRegistration";
import CoursePlayer from "./pages/Student/CoursePlayer";
import Quiz from "./pages/Student/Quiz";
import Leaderboard from "./pages/Student/LeaderBoard";

import AdminLogin from "./pages/Admin/AdminLogin";
import Dashboard from "./pages/Admin/Dashboard";
import Videos from "./pages/Admin/Videos";
import AddVideo from "./pages/Admin/AddVideo";
import EditVideo from "./pages/Admin/EditVideo";
import Assignments from "./pages/Admin/Assignments";
import AddAssignment from "./pages/Admin/AddAssignment";
import EditAssignment from "./pages/Admin/EditAssignment";
import AssignmentMark from "./pages/Admin/AssignmentMarks";
import Quizzes from "./pages/Admin/Quizzes";
import AddQuiz from "./pages/Admin/AddQuiz";
import EditQuiz from "./pages/Admin/EditQuiz";

import NavBar from "./components/NavBar";
import NotFound from "./components/NotFound";

function App() {
  const authCheck = useAuthCheck();
  const auth = useSelector((state) => state?.auth?.user);

  return !authCheck ? (
    <div>Checking authentication...</div>
  ) : (
    <BrowserRouter>
      {auth && (
        <div className="navbar">
          <NavBar />
        </div>
      )}

      <Routes>
        {/* Home Page */}
        <Route
          path="/home"
          element={
            <PublicRoute>
              <HomePage />
            </PublicRoute>
          }
        />

        {/* Student Landing Page */}
        {["/", "/login", "/student", "/student/login"].map((path, index) => (
          <Route
            path={path}
            key={index}
            element={
              <PublicRoute>
                <StudentLogin />
              </PublicRoute>
            }
          />
        ))}

        {/* Student Registration Page */}
        <Route
          path="/register"
          element={
            // <PublicRoute>
            <StudentRegistration />
            // </PublicRoute>
          }
        />

        <Route
          path="/student/:studentId/quiz/:quizId"
          element={
            <PrivateRoute>
              <Quiz />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/:studentId/leaderboard"
          element={
            <PrivateRoute>
              <Leaderboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/:studentId/videos/:videoId"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />

        {/* Admin Routes */}

        {/* Adming Logging Page */}
        {["/admin", "/admin/login"].map((path, index) => (
          <Route path={path} key={index} element={<AdminLogin />} />
        ))}

        {/* Admin Dashboard */}
        <Route path="/admin/dashboard" element={<Dashboard />} />

        {/* Videos */}
        <Route path="/admin/videos" element={<Videos />} />

        <Route path="/admin/addVideo" element={<AddVideo />} />

        <Route path="/admin/:videoId/editVideo" element={<EditVideo />} />

        {/* Assignments */}
        <Route path="/admin/assignments" element={<Assignments />} />

        <Route path="/admin/assignmentMark" element={<AssignmentMark />} />

        <Route path="/admin/addAssignment" element={<AddAssignment />} />

        <Route
          path="/admin/:assignmentId/editAssignment"
          element={<EditAssignment />}
        />

        {/* Quizzes */}

        <Route path="/admin/quizzes" element={<Quizzes />} />

        <Route path="/admin/addQuiz" element={<AddQuiz />} />

        <Route path="/admin/:quizId/editQuiz" element={<EditQuiz />} />

        {/* Not found page */}
        <Route
          path="/*"
          element={
            <>
              {!auth && <NavBar />}
              <NotFound />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
